import { useContext, useState } from 'react'

import { ChevronDoubleRightIcon } from '@heroicons/react/24/solid'

import Modal from '../../../../../components/modals/GenericModal'
import { translateMeasure } from '../../../../../utils/translate'
import {
  DispatchProductContext,
  FieldProductData,
  VisualData,
} from './ProductMovementStep'
import QuantitySelector from './QuantitySelector'
import VariationProductContainer from './VariationProductContainer'

export default function SendList() {
  const { products, fields } = useContext(DispatchProductContext)
  const [modal, setModal] = useState<FieldProductData | null>(null)
  const [variationModal, setVariationModal] = useState<VisualData | null>(null)

  //Get if available product is 0 ---------------------------------------------------------
  const lessEqualZero = (value: number | undefined) => {
    if (value === undefined) return false
    if (value <= 0) {
      return true
    } else {
      return false
    }
  }
  //---------------------------------------------------------------------------------------

  //onClick product event ------------------------------------------------------------------
  const onClickProduct = (item: VisualData) => {
    if (item.variations.length !== 0) {
      setVariationModal(item)
    } else {
      const data: FieldProductData = {
        available: item.available,
        measure: item.measure,
        productName: item.name,
        productId: item.productId,
      }
      setModal(data)
    }
  }
  //--------------------------------------------------------------------------------------
  return (
    <>
      {products!.map((item, idx) => {
        const index = fields!.findIndex(
          (elem) => elem.productId === item.productId
        )

        const variationQuant = (varId: number) => {
          return fields!.find((elem) => elem.variationId === varId)?.quantity
        }

        const quantity = fields!
          .filter((elem) => elem.productId === item.productId)
          .reduce((t, v) => (v.quantity ?? 0) + t, 0)

        return (
          <button
            key={idx}
            type="button"
            className={`my-2 inline-flex w-full items-center rounded-md border border-slate-200 p-5 shadow-md ${
              index !== -1 && 'ring-2 ring-slate-500'
            } ${
              lessEqualZero(item.available) ? 'bg-red-50' : 'hover:bg-slate-50'
            }`}
            onClick={() => index === -1 && onClickProduct(item)}
          >
            <div className="flex flex-grow flex-col">
              <p className="text-md text-start font-semibold">{item.name}</p>
              {item.variations.map((variation, idx) => (
                <div
                  key={idx}
                  className="inline-flex gap-3 pl-2 text-sm text-gray-400"
                >
                  <p>{`${variation.name} `}</p>
                  <p
                    className={
                      variationQuant(variation.id) ? 'line-through' : ''
                    }
                  >{`${Number(variation.available)} ${translateMeasure(
                    item.measure
                  )}`}</p>
                  {variationQuant(variation.id) && (
                    <p>{`${variation.available - variationQuant(variation.id)} ${translateMeasure(
                      item.measure
                    )}`}</p>
                  )}
                </div>
              ))}
            </div>
            <div className="flex flex-shrink flex-col gap-y-2">
              <p
                className={`text-sm text-slate-400 ${
                  index !== -1 && 'line-through'
                }`}
              >
                Disponible:{' '}
                {`${Number(item.available)} ${translateMeasure(item.measure)}`}
              </p>
              {index !== -1 && (
                <>
                  <p className={`text-sm text-slate-400`}>
                    Disponible:{' '}
                    {Math.round((item.available - (quantity ?? 0)) * 10000) /
                      10000}
                    {translateMeasure(item.measure)}
                  </p>
                  <span className="flex items-center justify-end">
                    {quantity}
                    <ChevronDoubleRightIcon className="h-5 text-slate-500" />
                  </span>
                </>
              )}
            </div>
          </button>
        )
      })}

      {modal && (
        <Modal state={!!modal} close={() => setModal(null)}>
          <QuantitySelector productData={modal} close={() => setModal(null)} />
        </Modal>
      )}
      {variationModal && (
        <Modal state={!!variationModal} close={() => setVariationModal(null)}>
          <VariationProductContainer
            product={variationModal}
            close={() => setVariationModal(null)}
          />
        </Modal>
      )}
    </>
  )
}
